import React, { createContext, useContext, useEffect, useMemo } from "react";
import { THEMES } from "./themes";
import { useLocalStorageState } from "../hooks/useLocalStorageState";

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {

  //const [themeKey, setThemeKey] = useLocalStorageState("appTheme", "light", { version: 1 });  
 const [themeKey, setThemeKey] = useLocalStorageState("appTheme", "classic", { version: 1 });


  const theme = THEMES[themeKey] ?? THEMES.light;

  useEffect(() => {
    // apply variables to <html> so everything inherits
    const root = document.documentElement;

    Object.entries(theme.vars).forEach(([k, v]) => root.style.setProperty(k, v));

    // helps native inputs + scrollbar in modern browsers
    root.dataset.theme = themeKey;
    root.style.colorScheme = theme.mode;
  }, [themeKey, theme]);

  const value = useMemo(
    () => ({
      themeKey,
      setThemeKey,
      themes: Object.entries(THEMES).map(([key, t]) => ({ key, name: t.name, mode: t.mode })),
    }),
    [themeKey, setThemeKey]
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used inside ThemeProvider");
  return ctx;
}
